import { useEffect, type FC, type PropsWithChildren } from 'react';

import { Locales } from 'constants/app';
import { useTranslate } from 'hooks';

import { Footer, Header } from '../../components/base/ui';

const BaseLayout: FC<PropsWithChildren> = ({ children }) => {
  const locale = localStorage.getItem('locale');
  const { changeLocale } = useTranslate();

  useEffect(() => {
    if (locale === Locales.en) {
      changeLocale(Locales.ru);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="flex min-h-dvh flex-col items-center font-nunito bg-base-dark-gray-200 justify-center md:px-14 md:py-8">
      <div className="md:max-h-[768px] flex flex-col flex-grow md:gap-8 justify-between items-center w-full">
        <Header />
        {children}
        <Footer />
      </div>
    </div>
  );
};

export { BaseLayout };
